import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Heading from '@/components/Typography/Heading';

type LogoProps = {
  direction?: 'row' | 'column';
  size: number;
  center?: boolean;
};

const SynclyLogo = (props: LogoProps) => {
  const fontSize =
    props.direction === 'column' ? props.size / 2.6 : props.size / 1.5;
  return (
    <Style
      d={props.direction || 'row'}
      a={props.center ? 'center' : 'flex-start'}
      j="center"
      style={{ fontSize: props.size }}
    >
      <div className="image-box">
        <img
          src="/assets/logo-syncly.svg"
          width="100%"
          height="100%"
          alt="Syncly"
        />
      </div>
      {props.direction === 'column' ? <Space h="0.3em" /> : <Space w="0.1em" />}
      <Heading
        type="h1"
        style={{ fontWeight: 800, fontSize }}
        className="text-gray-950"
      >
        Syncly
      </Heading>
    </Style>
  );
};

const Style = styled(Flex)`
  .image-box {
    width: 1em;
    height: 1em;
  }
`;

export default SynclyLogo;
